import { useCallback, useEffect, useState } from 'react';
import { dao } from '@platform/dao';
import type { IAttachment } from '@platform/core/types';
import type { IFilePreview } from './IFilePreview';

/** Збереження blob у браузері під іменем файлу (тимчасове посилання з атрибутом download). */
function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Дії з файлом поля: завантаження через DAO (з тими самими заголовками авторизації, що й решта запитів) і попередній перегляд
 * зображення чи PDF за blob-адресою, яка звільняється при закритті; busy — триває запит.
 */
export function useFileActions() {
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState<IFilePreview | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview.url); }, [preview]);
  const run = useCallback(async (file: IAttachment, show: boolean) => {
    setBusy(true); setFailed(false);
    try {
      const result = await dao.collaboration.download(file.id, file.fileName);
      if (show) setPreview({ url: URL.createObjectURL(result.blob), mimeType: file.mimeType || result.blob.type, fileName: file.fileName });
      else saveBlob(result.blob, result.fileName);
    } catch { setFailed(true); } finally { setBusy(false); }
  }, []);
  return { busy, failed, preview, download: (f: IAttachment) => void run(f, false), open: (f: IAttachment) => void run(f, true), close: () => setPreview(null) };
}
